import React from 'react';
import ReactDOM from 'react-dom';
import { List, Icon, Avatar } from 'antd';
import { convertModuleByGuid } from "./SgiCompComm"
import { getConstByKey } from './sgiBaseComp/SgiCommon';

const IconText = ({ type, text, onClick }) => (
    <span onClick={(typeof onClick == "function") ? onClick : null}>
        <Icon type={type} style={{ marginRight: 8 }} />
        {text}
    </span>
);

class SgiList extends React.Component {

    // //这个暂时不好用 以后在处理
    // static defaultProps = {
    // };  // 注意这里有分号
    // static propTypes = {
    // };  // 注意这里有分号

    constructor(props) {
        super(props);
        this.state = {
            listProps: { style: { heigth: '100%', width: '100%', padding: "0 20px" } },//list全局属性
            listItemProps: { style: { heigth: '100%', width: '100%' } },//item属性
            listItems: [], //子组件数组
            dataSource: this.props.dataSource || [],//{data},

            // renderItem : undefined,//{item => (<List.Item>{item}</List.Item>)},
            // bordered : true,//是否展示边框	boolean	false
            // footer : undefined,//列表底部	string|ReactNode	-
            // grid : undefined,//列表栅格配置	object	-
            // header : undefined,//列表头部	string|ReactNode	-
            // itemLayout : undefined,//设置 List.Item 布局, 设置成 vertical 则竖直样式显示, 默认横排	string	-
            // loading : undefined,//当卡片内容还在加载中时，可以用 loading 展示一个占位	boolean|object (更多)	false
            // locale : undefined,//默认文案设置，目前包括空数据文案	object	emptyText: '暂无数据'
            // loadMore : undefined,//加载更多	string|ReactNode	-
            // pagination : undefined,//对应的 pagination 配置, 设置 false 不显示	boolean|object	false
            // size : undefined,//list 的尺寸	default | middle | small	default
            // split : undefined,//是否展示分割线	boolean	true

            // ctnProps: { style: {} },//form属性
            // listProps: { style: { heigth: '100%', width: '100%' } },//list全局属性
            // listTitleProps: { style: {} },//list的title属性
            // listBodyProps: { style: {} },//list的body属性
            // listItems: [], //面板下控件数组loading
            // loading: false,
            // toolbarTopItems: [],
            // toolbarBottomItems: []
        };
    }

    /**
     * 根据描述创建list
     * @param {父组件} parentModule 
     * @param {描述} moduleDesc       
     * @param {对象工厂} objFct 
     * @param {make类型} type 
     */
    list_mk(parentModule, moduleDesc, objFct, type) {
        //获取需要展示的数据信息
        if (!moduleDesc) {
            return;
        }

        this.state.listItems = []; //再次渲染的时候清空

        //转换基础属性
        this.AddAttribute(moduleDesc, this.state.listProps, this.state.listItemProps, parentModule, objFct);
        //绑定事件
        // this.bindEvent(moduleDesc, this.state.listProps);
        //组装form表单下的控件信息
        // if (type !== "dnd") this.fitListItems(moduleDesc, this.state.listItems, objFct, type);
    }

    /**
     * 根据描述组装子对象
     * @param {描述信息} moduleDesc 
     * @param {属性} formProps 
     */
    fitListItems(moduleDesc, listItems, objFct, type) {
        // var me = this;

        // let bdInst = moduleDesc.bdInst;
        // if(!bdInst) return;
        // let datas = objFct.get(bdInst);
        // if(!Array.isArray(datas)) return;
        // datas.forEach(data => {

        // });

        // listData.forEach(data => {

        //     // listItems.push(<List.Item key={item.title} extra={item.description}/>);
        //     listItems.push(convertModuleByGuid(this, moduleDesc, null, objFct, type));
        // });

        // let cldSet = moduleDesc.cldSet;
        // if (cldSet && cldSet.length && cldSet.length > 0) {
        //     cldSet.forEach((item, index) => {
        //         if (item.desId === AllCompGUID.TOOLBAR) {
        //             if (!item.tlbAlg || item.tlbAlg == 'top' || item.tlbAlg == 'left') {
        //                 this.state.toolbarTopItems.push(convertModuleByGuid(this, item, null, objFct, type));
        //             } else {
        //                 this.state.toolbarBottomItems.push(convertModuleByGuid(this, item, null, objFct, type));
        //             }
        //         } else {
        //             listItems.push(convertModuleByGuid(me, item, null, objFct, type));
        //         }
        //     });
        // }
    }

    /**
     * 绑定事件
     * @param {*} moduleDesc
     * @param {*} tabsProps
     */
    bindEvent(moduleDesc, tabsProps, functions, type) {
        // //拖拽模式 不生成事件
        // var lsn = moduleDesc.tabLsn;// 选项卡监听器
        // // var lsn = "tool.sgiLogger.log('11111111111111111',ComponentManager)"
        // if (lsn && type != 'dnd') {
        //     try {
        //         var $tcl = new Function("module", "objFct", "activeKey", lsn);
        //         functions.tab = $tcl;
        //     } catch (e) {
        //         sgiLogger.eventErr(e);
        //     }
        // }
        // tabsProps.onChange = SgiEventHandler.tcl.bind(this);
    }

    refresh = () => {
        this.loaded = false;
        this.setState({ loading: false });
    }

    //渲染并返回一个虚拟DOM
    render() {

        if (!this.loaded) {
            let { parentModule, moduleDesc, objFct, type } = this.props;
            //组装属性
            this.list_mk(parentModule, moduleDesc, objFct, type);
            this.loaded = true;
        }

        tool.sgiLogger.log("dataSource", this.state.listProps.dataSource);

        return (
            <List {...this.state.listProps}>
                {/* <List.Item {...this.state.listItemProps}> */}
                {/* {this.state.listItems} */}
                {/* </List.Item> */}
            </List>
        )
    }

    /**
     * 属性转换
     * @param {描述信息} moduleDesc 
     * @param {属性} listProps 
     */
    AddAttribute(moduleDesc, listProps, listItemProps, parentModule, objFct) {

        // var type;
        // if (parentModule && parentModule.state && parentModule.state.itemListType) {
        //     type = parentModule.state.itemListType;
        // }

        // listProps.itemLayout = moduleDesc.itemLayout || "vertical";
        // listProps.size = "large";
        // listProps.pagination = {
        //     onChange: (page) => {
        //         tool.sgiLogger.log(page);
        //     },
        //     pageSize: 3,
        // };
        let bdInst = getConstByKey(this, moduleDesc.bdInst);
        if (bdInst && objFct) listProps.dataSource = objFct.get(bdInst);
        // listProps.dataSource = listData;

        // listProps.footer = (<div><b>ant design</b> footer part</div>);
        let listStyle = moduleDesc.listStyle;
        if (listStyle == "image") {
            listProps.itemLayout = "vertical";
            listProps.renderItem = item => (
                <List.Item
                    key={item.title}
                    actions={this.getIconTexts(item.actions)}
                    extra={<img {...item.extra} />}>
                    <List.Item.Meta
                        // avatar={<Avatar src={item.avatar} />}
                        title={<a href={item.href}>{item.title}</a>}
                        description={this.doSthForStr(item.description)}
                    />
                    {this.doSthForStr(item.content)}
                </List.Item>
            );
        } else if (listStyle == "avatar") {
            listProps.itemLayout = "horizontal";
            listProps.renderItem = item => (
                <List.Item
                    actions={this.getAs(item.actions)}>
                    <List.Item.Meta
                        avatar={<Avatar src={item.avatar} />}
                        title={<a href={item.href}>{item.title}</a>}
                        description={item.description}
                    />
                    <div>{item.content}</div>
                </List.Item >
            )
        }

        // var text = listProps.te;//公共方法里已从资源获取//Resource.getTRByPrm(moduleDesc).te; //form标题
        // if (text) listProps.header = text;

        // var isTtl = moduleDesc.isTtl; //form是否显示标题
        // if (!isTtl) {
        //     listTitleProps.style.display = "none";
        // } else {
        //     listTitleProps.style.display = undefined;
        // }

    }

    getIconTexts = (data) => {
        if (!data) return null;
        return (
            data.map((item) => {
                return <IconText {...item} />
            })
        );
    }
    getAs = (data) => {
        if (!data) return null;
        return (
            data.map((item) => {
                return <a {...item} >{item.text}</a>
            })
        );
    }
    doSthForStr(str) {
        if (!str) return str;
        let strArr = str.split("\r\n");
        return strArr.map(s => <div>{s}</div>);
    }

}

export { SgiList };
export default SgiList;



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiList.js